/* eslint-disable react/no-unescaped-entities */
import react from 'react'

interface FieldDescriptionProps {
  header: string
  description: string
  googleFormula: string
  bingFormula: string
  facebookFormula: string
  checked: boolean
  selectHandler: () => void
}

const FieldDescription = (props: FieldDescriptionProps) => {
  const [showDetails, setShowDetails] = react.useState(false)

  return (
    <section>
      <label className='flex items-center'>
        <input type="checkbox" className='h-6 w-6' checked={props.checked} onChange={props.selectHandler}/>
        <span className="mx-2">{props.header}</span>
      </label>
      <p className='text-sm italic text-slate-600 mt-1 mb-0'>{props.description}</p>
      {
        showDetails ?
          <a onClick={() => setShowDetails(false)} className='text-sm text-blue-500'>Hide formula</a> :
          <a onClick={() => setShowDetails(true)} className='text-sm text-blue-50 hidden'>Show formula</a>
      }
      <div className={`${showDetails ? 'block': 'hidden'} mt-3 p-4 bg-white`}>
        <h4 className='text-md underline'>Google</h4>
        <p className='text-sm italic text-slate-600 mt-0 mb-4'>{props.googleFormula}</p>
        <h4 className='underline'>Bing</h4>
        <p className='text-sm italic text-slate-600 mt-0 mb-4'>{props.bingFormula}</p>
        <h4 className='underline'>Facebook</h4>
        <p className='text-sm italic text-slate-600 mt-0'>{props.facebookFormula}</p>
      </div>
      <div className='mb-0 h-6'>&nbsp;</div>
    </section>
  )
}

export default FieldDescription